import type { CurrencyCode } from '@bbpos/types';
import type { SubscriptionPlan } from '@/types/subscription';

/**
 * A plan's price for a tenant in `currency` (QA SS4-001): the price the
 * platform entered in that currency, else the INR base price — shown, and
 * billed, in INR. Mirrors SubscriptionService.priceFor in the API.
 */
export function planPrice(
  plan: Pick<SubscriptionPlan, 'price_monthly' | 'price_yearly' | 'prices'>,
  currency: CurrencyCode,
  cycle: 'monthly' | 'yearly',
): { amount: number; currency: CurrencyCode } {
  const own = plan.prices?.find((p) => p.currency === currency);
  if (own) return { amount: cycle === 'yearly' ? own.price_yearly : own.price_monthly, currency };
  return { amount: cycle === 'yearly' ? plan.price_yearly : plan.price_monthly, currency: 'INR' };
}
